import { Controller } from '@hotwired/stimulus';
import { camelCase, upperFirst } from 'lodash';
import Chart from 'chart.js/auto';
import { color as chartColor } from 'chart.js/helpers'
import autocolors from 'chartjs-plugin-autocolors';
import moment from 'moment';

import ChartCanvas from '../../models/chart_canvas';

export class ReportsController extends Controller {
  static values = { report: Object }
  static targets = [
    'chart',
    'itemTotal',
    'cardItemTotal',
    'cashItemTotal',
    'roomChargeTotal',
    'tipTotal',
    'canvasTemplate'
  ]

  connect() {
    this.init();
    this.populateMoneyCards();

    if (this.chartModel.data.length === 0) {
      this.displayNoRecords()
    } else {
      return this.drawChart();
    }
  }

  disconnect() {
    this.chart.destroy();
  }

  displayNoRecords() {
    this.canvasTemplateTarget.classList.remove('grid');
    this.canvasTemplateTarget.classList.add('text-gray-500', 'text-center', 'p-10');

    this.canvasTemplateTarget.innerHTML = 'There is no data to display';
  }

  drawChart() {
    for (const [canvas, chartType] of Object.entries(this.chartMap())) {
      new Chart(this[`${canvas}Target`], { // eslint-disable-line no-new
        type: chartType,
        data: {
          labels: this.chartModel.labels,
          series: this.chartModel.series,
          datasets: this.datasets()
        },
        options: this.getDefaultOptions(chartType, chartColor),
      });
    }
    Chart.register(autocolors);
  }

  init() {
    this.startDate = moment(this.reportValue.starting);
    this.endDate = moment(this.reportValue.ending);
    let dashboardElement = document.getElementById('dashboard');
    let destinationId = dashboardElement.dataset.dashboardDestinationId

    this.chartModel = ChartCanvas.fromAttributes({
      total: null,
      labels: null,
      series: null,
      data: null,
      destinationId: parseInt(destinationId),
      ownerId: null, // TODO: update this.. it should be passed in from the view.
      startDate: this.reportValue.starting,
      endDate: this.reportValue.ending
    });

    let formattedReportData = this.formatReportData();
    this.chartModel.labels = formattedReportData.labels;
    this.chartModel.data = formattedReportData.data;
    this.chartModel.series = formattedReportData.series;
    this.chartModel.total = this.getTotalRow();
  }

  populateMoneyCards() {
    for (const [total, value] of Object.entries(this.chartModel.total)) {
      let targetName = camelCase(total);

      if (this[`has${upperFirst(targetName)}Target`]) {
        this[`${targetName}Target`].innerHTML = this.floatToMoney(value);
      }
    }
  }

  moneyToFloat(money) {
    const cents = money.fractional || money.cents;
    return parseFloat((parseFloat(cents) * 0.01).toFixed(2));
  }

  floatToMoney(float) {
    let usd = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });

    return usd.format(float)
  }

  getDefaultOptions() {
    return {};
  }

  getTotalRow() {
    return {};
  }
}
